import { useEffect, useState } from "react";
import {
    Box,
    Chip,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Link,
    Radio,
    RadioGroup,
    Button,
} from "@mui/material";
import { request } from "@/Api";
import { MakeOSIcon, MakersIcon } from "@/common/CommonComponents";

export const ElicitationResponseRadios = ({ options, onAccept, onReject }) => {
    const [selected, setSelected] = useState(null);
    const [result, setResult] = useState(null);

    const handleAccept = () => {
        onAccept(selected);
        setResult("accepted");
    };

    const handleCancel = () => {
        onReject(selected);
        setResult("rejected");
    };

    const handleChange = (newVal) => {
        setSelected(newVal.target.value);
    };

    return (
        <Box>
            <FormControl>
                <RadioGroup value={selected} onChange={handleChange}>
                    {options.map((option) => {
                        const val = option.value || option;
                        const component = option.component || option;
                        return (
                            <FormControlLabel
                                key={val}
                                value={val}
                                control={<Radio />}
                                label={component}
                            />
                        );
                    })}
                </RadioGroup>
            </FormControl>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "left",
                    gap: 2,
                    paddingTop: 2,
                }}
            >
                <Button
                    disabled={result != null}
                    color="success"
                    onClick={handleAccept}
                >
                    {"Confirm"}
                </Button>
                <Button
                    disabled={result != null}
                    color="error"
                    onClick={handleCancel}
                >
                    {"Cancel"}
                </Button>
            </Box>
        </Box>
    );
};

export const ElicitationResponseTemplateBidRadios = ({ onConfirm }) => {
    const [templates, setTemplates] = useState([]);
    const getTemplateBids = () => {
        request
            .get("/bid-templates", { params: { set: "active" } })
            .then((response) => {
                setTemplates(response.data);
            });
    };
    useEffect(() => {
        getTemplateBids();
    }, []);
    const handleAccept = (bid_id) => {
        const template = templates.find((t) => t.bid_id == bid_id);
        onConfirm({
            accepted: true,
            bid_id: template.bid_id,
            is_public: template.public,
        });
    };
    const handleReject = () => {
        onConfirm({ accepted: false });
    };
    return (
        <ElicitationResponseRadios
            options={templates.map((template) => ({
                value: template.bid_id,
                component: (
                    <Link
                        sx={{ fontSize: 14 }}
                        target="_blank"
                        href={
                            template.public ? null : `/bids/${template.bid_id}`
                        }
                    >
                        <Grid
                            container
                            spacing={1}
                            sx={{ width: "100%", paddingTop: 0.8 }}
                        >
                            <Grid item>{template.name}</Grid>
                            <Grid item xs={2}>
                                {template.public && <MakersIcon />}
                            </Grid>
                        </Grid>
                    </Link>
                ),
            }))}
            onAccept={handleAccept}
            onReject={handleReject}
        />
    );
};

export const ElicitationResponseBool = ({ onChoose }) => {
    const [result, setResult] = useState(null);
    return (
        <Box sx={{ textAlign: "center" }}>
            <Box sx={{ display: "flex", justifyContent: "left", gap: 2 }}>
                <Chip
                    disabled={result != null}
                    label={"Yes"}
                    clickable
                    color="success"
                    onClick={() => {
                        onChoose({ accepted: true });
                        setResult(true);
                    }}
                />
                <Chip
                    disabled={result != null}
                    label={"No"}
                    clickable
                    color="error"
                    onClick={() => {
                        onChoose({ accepted: false });
                        setResult(false);
                    }}
                />
            </Box>
        </Box>
    );
};
